import { AppBar, Box, Toolbar } from '@mui/material'
import { useLogout } from '../../api/auth'
import ActionsPanel from '../common/ActionsPanel'
import HeaderTitle from '../common/HeaderTitle'

interface Props {
  year?: string
  number?: string
  stageName?: string
  stageId?: string
}

export default function ProcessPageHeader({
  year = '',
  number = '',
  stageName,
  stageId,
}: Props) {
  const logout = useLogout()

  return (
    <AppBar position="sticky">
      <Toolbar>
        <HeaderTitle />
        <Box>
          <ActionsPanel />
        </Box>
      </Toolbar>
    </AppBar>
  )
}
